import _ from 'lodash';
import { getField, updateField } from 'vuex-map-fields';
const state = {
    fotos: [],
    video: null
};
const mutations = {
    updateField,
    updateFotos: (state, payload) => {
        state.fotos = payload;
    },
    updateVideo: (state, payload) => {
        state.video = payload;
    },
    agregarFoto: (state, payload) => {
        //console.log("LLego!!!!!", payload);
        if(state.fotos == undefined){
            state.fotos = [];
        }
        state.fotos.push(payload);
        //console.log("LLego2!!!!!", state.fotos);
    },
    removeFoto: (state, payload) => {
        state.fotos.splice(payload, 1);
    },
    updateFromReporte: (state, payload) => {
        if(payload.inspeccion_mecanica){
            const {fotos, video} = payload.inspeccion_mecanica;
            state.fotos = fotos;
            state.video = video;
        }else{
            const {fotos, video} = payload.fotosvideo;
            state.fotos = fotos;
            state.video = video;
        }
    }
};
const getters = {
    getField
};
export default {
    namespaced: true,
    state,
    mutations,
    getters
}
